export default "/images/vendor/flag-icon-css/flags/4x3/gg.svg?6b23b5b1092e831766f94b8df740deff";